module.exports = __webpack_public_path__ + "static/media/regionMR_2022.2a99f18b.png";